var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 96,
    viewBox: "0 0 60 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.699 75.398C41.0974 76.0972 40.3982 76.7964 39.5974 77.5972C46.2966 78.4956 50.8984 80.398 50.8984 82.4956C50.8984 85.4956 41.6992 87.9956 30.2964 87.9956C18.8984 87.9956 9.6944 85.4956 9.6944 82.4956C9.6944 80.394 13.9952 78.5972 20.3934 77.6948C19.6942 76.9956 18.995 76.2964 18.3934 75.4956C9.39339 77.1948 3.1944 80.7964 3.1944 84.894C3.1944 90.6948 15.3934 95.394 30.3934 95.394C45.3934 95.394 57.5924 90.6948 57.5924 84.894C57.6002 80.6987 51.1002 77.101 41.6974 75.3979L41.699 75.398Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30.5C60 13.898 46.602 0.5 30 0.5C13.398 0.5 0 13.898 0 30.5C0 47 30 84.199 30 84.199C30 84.199 60 47 60 30.5ZM17.898 30.5C17.898 23.8008 23.2964 18.398 30 18.398C36.6992 18.398 42.102 23.7964 42.102 30.5C42.102 37.1992 36.7036 42.602 30 42.602C23.3008 42.5004 17.898 37.102 17.898 30.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.0eaf50dba291ee9b1ad7ebd4b3e96311.svg";
export { ForwardRef as ReactComponent };